import React from 'react'
import './DynamicPage.css'

const DynamicPage = ({ contentData }: { contentData: any }) => {
    return (
        <div>
            {/* breadcrumb */}
            <div
                className="site-breadcrumb"
                style={{ background: "url(assets/img/breadcrumb/01.jpg)" }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{contentData?.title}</h2>
                    <ul className="breadcrumb-menu">
                        <li>
                            <a href="/">Home</a>
                        </li>
                        <li className="active">{contentData?.title}</li>
                    </ul>
                </div>
            </div>
            {/* breadcrumb end */}
            <div className="about-area py-120">
                <div className="container">

                    {
                        contentData?.content && <div className="dynamic-page" dangerouslySetInnerHTML={{ __html: contentData?.content }} />
                    }
                </div>
            </div>
        </div>
    )
}

export default DynamicPage
